import React from 'react';
import { simpleNotification } from '../../utils/notifications';
import './ProductSales.scss';

class ProductDetailModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showQRCode: false,
      promotionLink: '',
      qrCodeDataURL: '',
    };
    this.qrCodeCanvasRef = React.createRef();
  }

  componentDidMount() {
    // 生成推广链接
    if (this.props.product) {
      this.generatePromotionLink();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.product !== this.props.product && this.props.product) {
      this.generatePromotionLink();
    }
  }

  generatePromotionLink = () => {
    const { product } = this.props;
    if (!product) return;

    // 生成推广链接（包含产品ID）
    const baseUrl = window.location.origin;
    const promotionLink = `${baseUrl}/buy-cdk/${product.id}`;
    
    this.setState({ promotionLink });
  }

  generateQRCode = () => {
    const { promotionLink } = this.state;
    if (!promotionLink) return;

    // 使用简单的二维码生成算法
    // 实际项目中建议使用 qrcode.react 或 qrcode 库
    const canvas = document.createElement('canvas');
    const size = 400;
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext('2d');

    // 绘制白色背景
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, size, size);

    // 绘制红色边框（橙色）
    const borderWidth = 4;
    ctx.strokeStyle = '#EF3937';
    ctx.lineWidth = borderWidth;
    ctx.strokeRect(borderWidth / 2, borderWidth / 2, size - borderWidth, size - borderWidth);

    // 二维码参数设置
    const modules = 29; // 版本3 = 29x29模块
    const quietZone = 2; // 边距2个色块
    const moduleSize = (size - borderWidth * 2) / (modules + quietZone * 2);
    const offset = borderWidth + quietZone * moduleSize;

    // 绘制纯黑色方正码点
    ctx.fillStyle = '#000000';
    
    // 使用链接生成伪随机模式
    const seed = promotionLink.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
    
    for (let i = 0; i < modules; i++) {
      for (let j = 0; j < modules; j++) {
        // 生成伪随机模式
        const random = Math.sin(seed + i * 7 + j * 13) * 10000;
        const shouldFill = (random - Math.floor(random)) > 0.5;
        
        if (shouldFill) {
          // 方正形状（正方形）
          ctx.fillRect(
            offset + j * moduleSize,
            offset + i * moduleSize,
            moduleSize,
            moduleSize
          );
        }
      }
    }

    // 添加中心游戏图片区域（方形，类似微信二维码风格）
    const centerSize = size / 4;
    const centerX = size / 2;
    const centerY = size / 2;
    const squareSize = centerSize;

    // 绘制白色方形背景
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(centerX - squareSize / 2, centerY - squareSize / 2, squareSize, squareSize);

    // 加载当前CDK游戏的图片
    const { product } = this.props;
    const gameImg = new Image();
    gameImg.crossOrigin = 'anonymous';
    gameImg.onload = () => {
      ctx.save();
      
      // 计算图片裁剪参数（截取中间部分，类似 object-fit: cover）
      const imgWidth = gameImg.width;
      const imgHeight = gameImg.height;
      const imgRatio = imgWidth / imgHeight;
      const targetSize = squareSize * 0.9; // 留出边距
      
      let sx, sy, sWidth, sHeight;
      
      if (imgRatio > 1) {
        // 横向图片，截取中间部分
        sHeight = imgHeight;
        sWidth = imgHeight;
        sx = (imgWidth - sWidth) / 2;
        sy = 0;
      } else {
        // 纵向图片，截取中间部分
        sWidth = imgWidth;
        sHeight = imgWidth;
        sx = 0;
        sy = (imgHeight - sHeight) / 2;
      }
      
      const dx = centerX - targetSize / 2;
      const dy = centerY - targetSize / 2;
      
      // 绘制方形图片
      ctx.drawImage(gameImg, sx, sy, sWidth, sHeight, dx, dy, targetSize, targetSize);
      
      ctx.restore();
      this.setState({ showQRCode: true, qrCodeDataURL: canvas.toDataURL() });
    };
    
    gameImg.onerror = () => {
      // 如果图片加载失败，使用游戏名称首字母
      ctx.fillStyle = '#EF3937';
      ctx.font = 'bold 36px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      const initial = product && product.name ? product.name.charAt(0).toUpperCase() : 'N';
      ctx.fillText(initial, centerX, centerY);
      this.setState({ showQRCode: true, qrCodeDataURL: canvas.toDataURL() });
    };
    
    // 使用产品图片
    gameImg.src = product && product.image ? product.image : '/study-bellwright.jpg';
  }

  copyPromotionLink = () => {
    const { promotionLink } = this.state;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(promotionLink).then(() => {
        simpleNotification({
          title: 'Success',
          message: 'Promotion link copied to clipboard!',
          level: 'success',
          position: 'tr',
          autoDismiss: 3,
        });
      }).catch(() => {
        simpleNotification({
          title: 'Error',
          message: 'Failed to copy link. Please try again.',
          level: 'error',
          position: 'tr',
          autoDismiss: 3,
        });
      });
    }
  }

  closeQRCode = () => {
    this.setState({ showQRCode: false });
  }

  downloadQRCode = () => {
    const { qrCodeDataURL } = this.state;
    const { product } = this.props;
    
    if (!qrCodeDataURL) return;

    // 创建下载链接
    const link = document.createElement('a');
    link.href = qrCodeDataURL;
    link.download = `QRCode-${product?.name || 'Product'}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // 显示成功提示
    simpleNotification({
      title: 'Success',
      message: 'QR Code downloaded successfully!',
      level: 'success',
      position: 'tr',
      autoDismiss: 3,
    });
  }

  render() {
    const { isOpen, product, onClose } = this.props;
    const { showQRCode, qrCodeDataURL } = this.state;

    if (!isOpen || !product) return null;

    return (
      <div className="product-detail-modal-overlay" onClick={onClose}>
        <div className="product-detail-modal" onClick={(e) => e.stopPropagation()}>
          <button className="modal-close-btn" onClick={onClose}>
            <i className="fa fa-times" />
          </button>

          {/* QR Code Modal */}
          {showQRCode && (
            <div className="qr-code-overlay" onClick={this.closeQRCode}>
              <div className="qr-code-modal" onClick={(e) => e.stopPropagation()}>
                <button className="qr-close-btn" onClick={this.closeQRCode}>
                  <i className="fa fa-times" />
                </button>
                <h3>Scan QR Code</h3>
                <div className="qr-code-container">
                  <img src={qrCodeDataURL} alt="QR Code" />
                </div>
                <button className="download-qr-btn" onClick={this.downloadQRCode}>
                  <i className="fa fa-download" /> Download QR Code
                </button>
                <p className="qr-instruction">
                  Scan this QR code to visit the product page
                </p>
              </div>
            </div>
          )}

          <div className="modal-content">
            <div className="modal-left">
              <h2>Simple Requirements:</h2>

              <div className="requirements-content">
                <p><strong>1)</strong> Include the hashtag <code>#Bellwright</code> in the Short's title or description.</p>

                <p><strong>2)</strong> Include Bellwright in your title.</p>
                <ul>
                  <li>Create your own original, engaging title that fits the Shorts format.</li>
                  <li>Example titles:
                    <ul>
                      <li>Bellwright Is Incredibly Fun – Don't Miss Out!</li>
                      <li>Why Bellwright Is a Must-Play Game Right Now</li>
                      <li>Join the Fun: Dive into Bellwright Today!</li>
                    </ul>
                  </li>
                  <li>(Do not copy these directly. Create your own.)</li>
                </ul>

                <p><strong>3)</strong> The provided assets must remain live in your Shorts for at least <strong>180 days</strong>.</p>
                <ul>
                  <li>Please do not delete them.</li>
                </ul>

                <div className="divider" />

                <h3>WHAT WE PROVIDE</h3>
                <ul>
                  <li>Curated media kit optimized for Shorts:
                    <ul>
                      <li>Vertical-format gameplay clips</li>
                      <li>Highlight moments</li>
                      <li>Engaging hooks for creators</li>
                    </ul>
                  </li>
                </ul>

                <div className="divider" />

                <h3>GAME REFERENCE</h3>
                <p>Steam Page: <a href="https://store.steampowered.com/app/1812450/" target="_blank" rel="noopener noreferrer">https://store.steampowered.com/app/1812450/</a></p>

                <div className="divider" />

                <p className="footer-text">
                  If you are interested and can meet the requirements, please reply to confirm.
                  We will then send the asset package directly. Thank you.
                </p>
              </div>
            </div>

            <div className="modal-right">
              <div className="product-summary">
                <div className="product-image">
                  <img src={product.image} alt={product.title} />
                </div>

                <h3 className="product-name">{product.title}</h3>

                <div className="product-details">
                  <div className="detail-row">
                    <span className="label">Price:</span>
                    <span className="value">{product.price} {product.currency || 'USD'}</span>
                  </div>
                  <div className="detail-row">
                    <span className="label">Commission:</span>
                    <span className="value commission">{product.commissionRate}%</span>
                  </div>
                  <div className="detail-row">
                    <span className="label">Stock:</span>
                    <span className="value">{product.stock !== undefined ? product.stock : '999999'}</span>
                  </div>
                </div>

                <div className="promotion-tools">
                  <h4>Promotion Tools</h4>
                  <button className="promo-btn primary" onClick={this.copyPromotionLink}>
                    <i className="fa fa-link" /> Generate Promotion Link
                  </button>
                  <button className="promo-btn secondary" onClick={this.generateQRCode}>
                    <i className="fa fa-qrcode" /> Generate QR Code
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProductDetailModal;
